import { gql } from "@apollo/client";
import Field from "controls/Field";
import FormDialog from "controls/FormDialog";
import { GLORYLEAGUE_WEBSITE_URL } from "helpers/constants";
import useAction from "hooks/useAction";
import useShowMessage from "hooks/useShowMessage";
import TextInput from "inputs/TextInput";
import React from "react";

export default function OpenSupportCaseDialog({ signupUuid, submittedFormData = {}, onClose }) {
  const showMessage = useShowMessage();
  const signupOpenSupportCase = useAction(gql`
    mutation OpenSupportCaseDialog($input: SignupOpenSupportCaseInput!) {
      signupOpenSupportCase(input: $input) {
        clientMutationId
      }
    }
  `);

  return (
    <FormDialog
      header="Open a Support Case"
      onClose={onClose}
      submitContent="Submit"
      onSubmit={async (formData) => {
        await signupOpenSupportCase({
          input: {
            signupUuid,
            ...formData,
          },
        });
        await showMessage({
          modal: true,
          header: <>Your support case has been submitted</>,
          content: (
            <>
              <p>We will review your support case and get back to you as soon as possible.</p>
            </>
          ),
        });
        window.location.href = GLORYLEAGUE_WEBSITE_URL;
      }}
    >
      {[
        ["Organisation", submittedFormData.orgName],
        ["Season", submittedFormData.competitionName],
        ["Grade", submittedFormData.leagueName],
        ["Team", submittedFormData.teamName],
        ["Your role in the team", submittedFormData.role],
        ["Registered Participant First Name", submittedFormData.firstName],
        ["Registered Participant Last Name", submittedFormData.lastName],
      ].map(([label, value]) => (
        <Field key={label} disabled label={label} value={value} input={<TextInput />} />
      ))}
      <Field name="message" label="Message" required input={<TextInput multiline minRows={5} />} />
    </FormDialog>
  );
}
